import { render } from "./KnowledgeInfo.vue?vue&type=template&id=a8cea238"
import script from "./KnowledgeInfo.vue?vue&type=script&lang=js"
export * from "./KnowledgeInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__